import React, {useCallback} from 'react';
import {
    Variation,
    Variations,
} from 'components/customer/Confirmation/Checkout/Variations';
import {useDeleteVariations} from 'components/customer/Confirmation/Checkout/helpers/useDeleteVariations';
import {
    removedExtraVariationIdsSet,
    removedExtraVariationIdsUnset,
    selectRemovedExtraVariationIds,
} from 'components/customer/Confirmation/store/confirmationSlice';
import {useGetExtraVariations} from 'components/customer/Confirmation/Checkout/helpers/useGetVariations';
import {getExtraVariationLabel} from 'components/customer/Job/helpers/getExtraVariationLabel';

export const ExtraVariations = () => {
    const {deleteVariation, restoreVariation, isDeleted} = useDeleteVariations(
        selectRemovedExtraVariationIds,
        removedExtraVariationIdsSet,
        removedExtraVariationIdsUnset
    );
    const {isLoading, isFetching, variations} = useGetExtraVariations();

    const getName = useCallback(
        (variation: Variation) =>
            getExtraVariationLabel({
                job_cabinet_appliance_id: variation.job_cabinet_appliance_id,
                product_label: variation.product_label,
                detail_label: variation.detail_label,
                name: variation.name ?? '',
            }),
        []
    );

    if (isLoading || isFetching || variations.length == 0) return null;

    return (
        <Variations
            getName={getName}
            deleteAction={deleteVariation}
            restoreAction={restoreVariation}
            isDeleted={isDeleted}
            variations={variations}
        />
    );
};
